<template>
  <div class="ghostbox">
    <div class="content">
      <div class="title">
        {{ t('general.item.none', { name: props.itemName }) }}
      </div>

      <div class="link">
        <RouterLink v-if="props.linkOptions != null" :to="props.linkOptions">
          {{ props.linkOptions.text }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import { RouterLink } from 'vue-router'

const props = defineProps({
  itemName: {
    type: String,
    required: true
  },
  linkOptions: {
    type: Object,
    required: false,
    default: null
  }
})

const { t } = useI18nUtils()
</script>

<style scoped>
.ghostbox {
  display: flex;
  justify-content: center;
  padding: 0.25rem;
  height: 175px;

  .content {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    flex-wrap: wrap;
    place-items: center;
    place-content: center;

    max-width: 500px;
    width: 100%;
    height: 100%;

    border: 1px dashed var(--color-background);
    border-radius: 8px;

    .title {
      padding: 0.15rem;
      font-size: 18px;
      font-weight: 700;
    }

    .link {
      display: flex;
      justify-content: center;
    }
  }
}
</style>